import React from 'react';
import ReadOnlyField from 'common/entity/generic/ReadOnlyField';
import VehicleModelIdInput from './VehicleModelIdInput';
import PersonaLimitsTable from 'common/entity/riderMaster/PersonaLimitsTable';
import RiderPersonaSkills from 'common/entity/riderMaster/RiderPersonaSkills';

const VehicleModelIdInputWithFleetTransporter = props => {
    const {
        entity: { vehicleModel },
        t,
        unitConverter,
        customResources
    } = props;
    let fleetType = '';
    let transporterId = '';
    let showLimits = false;
    let limits;
    let skills;
    if (vehicleModel) {
        ({ limits, skills } = vehicleModel);
        fleetType = vehicleModel.fleetType;
        transporterId = vehicleModel.transporterId?.transporterId;
        showLimits = limits ? limits.hasNonEmptyValues() : false;
    }
    const translatedFleetType = fleetType
        ? t(`masterVehicleProperties.fleetTypeOptions.${fleetType}`)
        : '';
    const fleetTransporter = (
        <>
            <ReadOnlyField
                label={t('masterVehicleProperties.transporterId')}
                value={transporterId}
            />
            <ReadOnlyField
                label={t('masterVehicleProperties.fleetType')}
                value={translatedFleetType}
            />
        </>
    );
    const limitsAndSkills = (
        <>
            {showLimits ? (
                <PersonaLimitsTable
                    t={t}
                    limits={limits}
                    unitConverter={unitConverter}
                    tableLabel="Resource limits"
                    showAllUnits
                    customResources={customResources}
                />
            ) : null}
            {skills?.size ? <RiderPersonaSkills t={t} data={skills} /> : null}
        </>
    );
    const details = (
        <>
            {limitsAndSkills}
            {fleetTransporter}
        </>
    );
    return <VehicleModelIdInput render={details} {...props} />;
};

export default VehicleModelIdInputWithFleetTransporter;
